<template>
  <div>
    <masonry :cols="cols" :gutter="{ default: '15px' }"
      class="masonry">
      <div class="card" :class="{'card__payments': !$route.params.id}">
        <h1 class="card__title" v-if="user && $route.params.id">{{ $t('messages.started_kickstarters_of') }} {{ user.full_name }}</h1>
        <h1 class="card__title" v-if="user && !$route.params.id">{{ $t('messages.my_kickstarters_started') }}</h1>
        <div class="card__description">
          <div v-if="$route.params.id">
            <p v-if="user" class="mb-3">
              <b-button v-b-tooltip.hover :title="$t('messages.messages_send')" :class="{ 'invisible': $store.state.userId == user.user_id }" variant="primary" :to="{ path: '/messages/' + slugText(user.user_id + '-' + user.full_name) }">
                <font-awesome-icon icon="comment"></font-awesome-icon>
              </b-button>
            </p>
            <p v-if="user && $route.params.id" class="mb-2">{{ user.city }}, {{ $t('countries.' + user.country) }}</p>
            <div id="userMap"></div>
          </div>
          <div v-if="!$route.params.id" class="pt-20 pt-0">
            <b-form-checkbox id="participant" v-if="participants.length > 0" v-model="participant" name="participant"
                             class="filterCheckbox filterParticipant">
              <div class="d-flex">
                <div class="flex-grow-1">{{ $t('messages.show_participant') }}</div>
                <div class="flex-grow-1">
                  <b-form-select v-model="params.participant" class="participantSelect">
                    <option :value="false"></option>
                    <option v-for="participant in participants" :key="'p-' + participant.id" :value="participant.id">{{ participant.full_name }}</option>
                  </b-form-select>
                </div>
              </div>
            </b-form-checkbox>
            <b-form-checkbox id="toDeliver" v-model="params.toDeliver" name="toDeliver" class="filterCheckbox"
              v-show="!!params.participant">
              {{ $t('messages.show_to_deliver_projects_only') }}
            </b-form-checkbox>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <project-tile v-if="projects" v-for="project in projects" :project="project"
                    :show-payments="!$route.params.id" :key="project.id"></project-tile>
    </masonry>
    <div class="load-more-wrapper">
      <b-button v-if="hasMore" variant="primary" class="w-100" @click="loadMore">
        {{ $t('messages.load_more') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import ProjectTile from '../components/project/ProjectTile'

import { defaultMixin } from '../mixin/default'
import { navigationMixin } from '../mixin/navigation'

import { userService } from '../services/user.service'
import { projectService } from '../services/project.service'

Vue.use(VueMasonry)

export default {
  name: 'user',
  metaInfo: function () {
    return {
      title: this.userTitle + ' - CrowdFinder',
      meta: [
        {
          'property': 'og:title',
          'content': this.userTitle,
          'vmid': 'og:title'
        }
      ]
    }
  },
  mixins: [ defaultMixin, navigationMixin ],
  components: { ProjectTile },
  data: function () {
    return {
      cols: {
        default: 6,
        1600: 5,
        1300: 4,
        1000: 2,
        700: 1
      },
      rows: 4,
      params: {
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        participant: this.$route.query.participant ? parseInt(this.$route.query.participant) : false,
        toDeliver: this.$route.query.toDeliver ? JSON.parse(this.$route.query.toDeliver) : false
      },
      user: null,
      hasMore: false,
      projects: [],
      initialized: false,
      participants: [],
      participant: !!this.$route.query.participant,
      timeout: null,
      map: {
        initialized: false
      }
    }
  },
  computed: {
    userTitle: function () {
      if (this.$route.params.id) {
        if (this.user != null) {
          return this.user.full_name
        }
      } else {
        return this.$i18n.t('messages.my_kickstarters_started')
      }
      return ''
    }
  },
  methods: {
    fetchUser: function () {
      let loader = this.$loading.show()
      let totalComplete = 0
      let totalMaxComplete = this.initialized ? 1 : 3

      let id = this.$route.params.id
      if (!id) {
        id = this.$store.state.userId
      }
      let store = this.$store

      if (!this.initialized) {
        userService.getBasic(id)
          .then((user) => {
            this.user = user
            totalComplete++
            if (totalComplete === totalMaxComplete) {
              loader.hide()
            }
          }, () => {
            store.commit('error', 'errors.user_fetch_different')
            totalComplete++
            if (totalComplete === totalMaxComplete) {
              loader.hide()
            }
          })

        projectService.fetchAllParticipants()
          .then((participants) => {
            this.participants = participants
            totalComplete++
            if (totalComplete === totalMaxComplete) {
              loader.hide()
            }
          }, () => {
            store.commit('error', 'errors.user_fetch_different')
            totalComplete++
            if (totalComplete === totalMaxComplete) {
              loader.hide()
            }
          })
      }

      let size = null
      let screenWidth = window.innerWidth
      for (let key in this.cols) {
        if (size === null) {
          if (key !== 'default' && screenWidth <= key) {
            size = this.cols[key]
          } else if (key === 'default') {
            size = this.cols[key]
          }
        }
      }
      size = (size * this.rows) - (this.params.page === 1 ? 1 : 0)

      let filter = _.merge(JSON.parse(JSON.stringify(this.params)), {
        page: this.initialized ? this.params.page : 1,
        size: this.initialized ? size : (this.params.page * size)
      })

      projectService.fetchOfUser(id, filter)
        .then((projects) => {
          if (this.params.page === 1) {
            this.projects = projects
          } else {
            this.projects = this.projects.concat(projects)
          }
          this.hasMore = projects.length === (this.initialized ? size : (this.params.page * size))
          if (!this.initialized) {
            this.$store.commit('moveToScrollPosition')
          }
          this.initialized = true
          totalComplete++
          if (totalComplete === totalMaxComplete) {
            loader.hide()
          }
        }, () => {
          this.initialized = true
          store.commit('error', 'errors.user_fetch_different')
          totalComplete++
          if (totalComplete === totalMaxComplete) {
            loader.hide()
          }
        })
    },
    initializeMap: function () {
      if (this.user && !this.map.initialized) {
        let container = document.getElementById('userMap')
        if (container) {
          // eslint-disable-next-line no-undef
          let map = new L.Map('userMap', {
            fullscreenControl: true,
            center: [0, 0],
            zoom: 10
          })
          // eslint-disable-next-line no-undef
          let icon = L.icon({
            iconUrl: Vue.prototype.$hostname.concat('/image/arrow-orange.png'),
            iconSize: [25, 30]
          })
          // eslint-disable-next-line no-undef
          let marker = new L.Marker([this.user.lat, this.user.lng], {
            icon: icon
          })
          marker.addTo(map)
          // eslint-disable-next-line no-undef
          let group = new L.FeatureGroup([
            marker
          ])
          map.panTo(group.getBounds().getCenter())
          // eslint-disable-next-line no-undef, no-template-curly-in-string
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }).addTo(map)
          this.map.initialized = true
        }
      }
    },
    loadMore: function () {
      this.params.page += 1
      this.load()
    },
    resetAndLoad: function () {
      this.params.page = 1
      this.load()
    },
    load: function () {
      let params = this.params
      let query = this.generateQueryParams(params)
      this.pushUrlState(query)
      this.fetchUser()
    }
  },
  created: function () {
    this.fetchUser()
  },
  mounted: function () {
    let self = this
    if (this.$route.params.id) {
      this.initializeMap()
    }
    window.addEventListener('resize', function () {
      self.map.initialized = false
      if (self.timeout) {
        clearTimeout(self.timeout)
      }
      self.timeout = setTimeout(function () {
        self.initializeMap()
      }, 1000)
    })
  },
  watch: {
    participant: function () {
      if (!this.participant) {
        this.params.participant = false
      }
      this.resetAndLoad()
    },
    'params.participant': function () {
      if (this.params.participant !== false) {
        if (this.participant === true) {
          this.resetAndLoad()
        } else {
          this.participant = true
        }
      } else {
        this.params.toDeliver = false
        if (this.participant === false) {
          this.resetAndLoad()
        } else {
          this.participant = false
        }
      }
    },
    'params.toDeliver': function () {
      this.resetAndLoad()
    },
    user: function () {
      if (this.$route.params.id) {
        this.initializeMap()
      }
    }
  },
  beforeDestroy: function () {
    clearTimeout(this.timeout)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .load-more-wrapper {
    margin-top: -20px;
    padding: 0px 10px 10px;
  }

  .masonry {
    padding: 10px;
  }

  .filterCheckbox {
    margin: 3px 0px;
  }

  .participantSelect {
    margin-left: 10px;
  }

  @media screen and (min-width: 701px) {
    .card {
      height: 425px;
    }

    .card__description {
      height: 100%;
    }

    .card__payments {
      height: 500px;
    }
  }

  .margin-top-fix {
    margin-top: 42px;
  }

  .clear {
    clear: both;
  }

  #userMap {
    width: 100%;
    height: 230px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/User.vue